import React from 'react';
import { ViralTopTen } from '@components/Charts/ViralTopTen';
import { DownloadScreenshot } from '@components/main-components/download-screenshot';
import { ModalContext } from '@context/modal';
import { ToastContext } from '@context/toast';
import { trackClickEvent } from '@lib/analytics';

export function DownloadViralScreenshotModal({ chartId }: { chartId: string }) {
  const { closeCancelModal } = ModalContext.useContainer();
  const { openToast } = ToastContext.useContainer();

  return (
    <DownloadScreenshot
      title="Share The Viral 10: Sounds"
      fileName="top-10-songs"
      closeModal={closeCancelModal}
      // TODO: linear.app/sound/issue/ENG-9185/add-missing-observability-in-fe
      onError={() =>
        openToast({
          text: 'There was an error downloading viral screenshot',
          variant: 'error',
        })
      }
      onDownload={() => {
        trackClickEvent({
          event: 'Download Viral Sounds JPG Clicked',
          properties: { sourceComponent: 'Share Viral Sounds Modal' },
        });
      }}
      landscapeHtml={<ViralTopTen chartId={chartId} type="landscape" />}
      portraitHtml={<ViralTopTen chartId={chartId} type="portrait" />}
      squareHtml={<ViralTopTen chartId={chartId} type="square" />}
    />
  );
}
